(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.popupCloseButton = {
    attach: function (context, settings) {
      once('popupCloseButton', '[data-popup-close-button]', context).forEach(
        function (button) {
          button.addEventListener('click', function () {
            button.closest('[data-popup]').setAttribute('data-show', 'false');
          });
        }
      );
    }
  };

  Drupal.behaviors.popupOpenButton = {
    attach: function (context, settings) {
      once('popupOpenButton', '[data-popup-open-button]', context).forEach(
        function (button) {
          button.addEventListener('click', function () {
            document
              .querySelector('[data-popup]')
              .setAttribute('data-show', 'true');
          });
        }
      );
    }
  };
})(Drupal, once);
